import PropTypes from "prop-types";
import { useRef } from "react";

import {
  Orientation,
  ToggleGroup,
} from "~/components/Base/ToggleGroup/ToggleGroup";
import { toToggleGroupValues } from "../shared/toToggleGroupValues";

export function RadioButtons({
  ariaDescribedBy,
  ariaLabelledBy,
  choices,
  layout,
  oid,
  onChange,
  readOnly,
  valid,
  value,
}) {
  const options = useRef(toToggleGroupValues(choices));

  return (
    <ToggleGroup
      ariaDescribedBy={ariaDescribedBy}
      ariaLabelledBy={ariaLabelledBy}
      choices={options.current}
      disabled={readOnly}
      id={oid}
      onChange={onChange}
      orientation={layout.orientation ?? Orientation.Horizontal}
      role="radio"
      valid={valid}
      value={value}
    />
  );
}

RadioButtons.propTypes = {
  ariaDescribedBy: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      choiceValue: PropTypes.string.isRequired,
      choiceText: PropTypes.string.isRequired,
    })
  ),
  oid: PropTypes.string,
  onChange: PropTypes.func,
  layout: PropTypes.shape({
    orientation: PropTypes.oneOf([
      Orientation.Vertical,
      Orientation.Horizontal,
    ]),
  }),
  readOnly: PropTypes.bool,
  valid: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
